import { FormBase } from 'core/components';

export default class PalletCreateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.NAME',
					rules: 'required',
				},
				{
					name: 'carrierTypeServiceTypeId',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'warehouseId',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.WAREHOUSE',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/PalletCreateForm.js